import { CardForm, InputTextForm } from '@/uiComponents/common';
import SelectForm from '@/uiComponents/common/selects/selectNew';

const AddressInformation = ({ t, className, countries, states, cities }) => {
  return (
    <>
      <CardForm title={t('addressInformation.title')} className={className}>
        <div className='row tw-mb-6'>
          <SelectForm
            name={'country'}
            options={countries}
            className={'col-6 tw-mb-6'}
            label={t('rowAddress.inputCountry.label')}
            placeholder={t('rowAddress.inputCountry.placeholder')}
            maxLength={510}
          />
          <SelectForm
            name={'state'}
            options={states}
            className={'col-6 tw-mb-6'}
            label={t('rowAddress.inputState.label')}
            placeholder={t('rowAddress.inputState.placeholder')}
            maxLength={510}
          />
          <SelectForm
            name={'city'}
            options={cities}
            className={'col-6 tw-mb-6'}
            label={t('rowAddress.inputCity.label')}
            placeholder={t('rowAddress.inputCity.placeholder')}
            maxLength={510}
          />
          {/* <InputTextForm
            name={'city'}
            className={'col-6 tw-mb-6'}
            label={t('rowAddress.inputCity.label')}
            placeholder={t('rowAddress.inputCity.placeholder')}
            maxLength={510}
          /> */}
          <InputTextForm
            name={'address'}
            className={'col-6 tw-mb-6'}
            label={t('rowAddress.inputAddress.label')}
            placeholder={t('rowAddress.inputAddress.placeholder')}
            maxLength={510}
          />
        </div>
      </CardForm>
    </>
  );
};

export default AddressInformation;
